import { Component, effect, inject, input, model } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { ModalComponent } from '../../shared/components/modal/modal.component';
import { CrudService } from '../../core/services/crud.service';
import { removeEmptyValues } from '../../shared/helpers';

@Component({
  selector: 'app-warehouse-form',
  imports: [ReactiveFormsModule, ModalComponent],
  templateUrl: './warehouse-form.component.html',
  styles: ``,
})
export class WarehouseFormComponent {
  private crudService = inject(CrudService);

  showModal = model(false);
  existingWarehouse = input(null);

  confirmationMessage = '';
  errorMessage = '';

  warehouseForm = new FormGroup({
    name: new FormControl('', Validators.required),
    location: new FormControl('', Validators.required),
  });

  buttonText = '';

  constructor() {
    effect(() => {
      if (this.showModal()) {
        if (this.existingWarehouse() !== null) {
          this.buttonText = 'Actualizar';

          this.warehouseForm.patchValue({
            name: (this.existingWarehouse() as any)['name'],
            location: (this.existingWarehouse() as any)['location'],
          });
        } else {
          this.buttonText = 'Crear';
          this.clearForm();
        }
      }
    });
  }

  submit() {
    const cleanUserForm = removeEmptyValues(this.warehouseForm.value);
    this.confirmationMessage = '';
    this.errorMessage = '';

    if (this.existingWarehouse() != null) {
      this.updateWarehouse(this.warehouseForm.value);
    } else {
      this.createWarehouse(cleanUserForm);
    }
  }

  createWarehouse(cleanUserForm: any) {
    this.crudService.createWarehouse(cleanUserForm).subscribe({
      next: (response: any) => {
        if (response.status === 201) {
          this.confirmationMessage = 'Almacen añadido';
          this.clearForm();
        }
      },
      error: (error: any) => {
        if (error.status === 409) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage = 'Error inesperado. Intente nuevamente.';
        }
        this.clearForm();
      },
    });
  }

  updateWarehouse(warehouseForm: any) {
    this.crudService
      .updateWarehouse((this.existingWarehouse() as any)['id'], warehouseForm)
      .subscribe({
        next: (response: any) => {
          if (response.ok) {
            this.close();
          }
        },
      });
  }

  cancel() {
    this.close();
  }

  close() {
    this.showModal.set(false);
  }

  clearForm() {
    this.warehouseForm.reset({
      name: '',
      location: '',
    });
  }
}
